export default __webpack_public_path__ + "static/media/norway-grants.042dfe1b.svg";